import { render, staticRenderFns } from "./Tracking.vue?vue&type=template&id=12bedb92&scoped=true"
import script from "./Tracking.js?vue&type=script&lang=js&external"
export * from "./Tracking.js?vue&type=script&lang=js&external"
import style0 from "./Tracking.css?vue&type=style&index=0&id=12bedb92&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bedb92",
  null
  
)

export default component.exports